import { Observable } from "../Observable.js";
function throttleTime(duration, config) {
  const leading = config?.leading ?? true;
  const trailing = config?.trailing ?? false;
  const setTimeoutFn = config?.setTimeout || setTimeout;
  const clearTimeoutFn = config?.clearTimeout || clearTimeout;
  return (source) => {
    return new Observable((subscriber) => {
      let throttled = false;
      let trailingValue;
      let hasTrailingValue = false;
      let timeoutId = null;
      const endThrottle = () => {
        if (timeoutId !== null) {
          clearTimeoutFn(timeoutId);
          timeoutId = null;
        }
        throttled = false;
        if (trailing && hasTrailingValue) {
          const valueToEmit = trailingValue;
          hasTrailingValue = false;
          trailingValue = void 0;
          Promise.resolve().then(() => {
            if (!subscriber.closed) {
              subscriber.next(valueToEmit);
              startThrottle();
            }
          });
        }
      };
      const startThrottle = () => {
        if (throttled) {
          return;
        }
        throttled = true;
        timeoutId = setTimeoutFn(() => {
          endThrottle();
        }, duration);
      };
      const subscription = source.subscribe({
        next: (value) => {
          if (!throttled) {
            if (leading) {
              subscriber.next(value);
            } else if (trailing) {
              trailingValue = value;
              hasTrailingValue = true;
            }
            startThrottle();
          } else if (trailing) {
            trailingValue = value;
            hasTrailingValue = true;
          }
        },
        error: (err) => {
          if (timeoutId !== null) {
            clearTimeoutFn(timeoutId);
            timeoutId = null;
          }
          throttled = false;
          subscriber.error(err);
        },
        complete: () => {
          if (timeoutId !== null) {
            clearTimeoutFn(timeoutId);
            timeoutId = null;
          }
          if (trailing && hasTrailingValue) {
            subscriber.next(trailingValue);
          }
          subscriber.complete();
        }
      });
      return () => {
        subscription.unsubscribe();
        if (timeoutId !== null) {
          clearTimeoutFn(timeoutId);
          timeoutId = null;
        }
      };
    });
  };
}
export {
  throttleTime
};
//# sourceMappingURL=throttleTime.js.map
